<template>
  <div class="p-1">
    <div class="h-20 py-3 flex items-center border-black-200 p-6 mt-5">
      <div class="flex w-full">
        <button
          :class="$colors.primary"
          class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
          @click="RouterBack()"
        >
          <i class="material-icons">chevron_left</i>
        </button>

        <div class="text-xl font-bold text-black-600">Details</div>
      </div>
    </div>
    <div class="bg-white p-4 m-4 rounded">
      <div class="mb-20">
        <h1 class="font-bold text-xl">Search</h1>
        <form class="flex items-center max-w-md">
          <input
            type="text"
            id="order-ref"
            v-model="filterOptions.orderRef"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-orange-500 focus:border-orange-500 block w-full p-2"
            placeholder="search using order reference"
          />
          <date-picker range class="p-3" v-model="filterOptions.dates"/>
        </form>
      </div>

      <StockInsights :isUserCEO="isUserCEO" />

      <div-table
        :config="configList"
        :data="content"
        :loading="loading"
        :paginate="paginate"
        @paginatation="paginatation"
      ></div-table>
    </div>
  </div>
</template>

<script>
import StockInsights from '../../components/Stock/StockInsights.vue';
import config from './configStock';
import moment from 'moment';
export default {
  props: {
    currentUser: { type: Object },
  },
  data() {
    return {
      configList: config.list,
      filterOptions: {
        orderRef: null,
        dates: [
          moment()
            .startOf('week')
            .toDate(),
          moment()
            .endOf('week')
            .toDate(),
        ],
      },
      loading: false,
      content: [],
     // currentUser: {},
      limit: 10,
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
    };
  },
  async mounted() {
    //await this.getUser();
    if (
      this.currentUser &&
      this.currentUser.type &&
      this.currentUser.type == 'Seller'
    ) {
      let pos = this.configList.columns
        .map(function(e) {
          return e.name;
        })
        .indexOf('Wharhouse name');
      if (pos != -1) this.configList.columns.splice(pos, 1);
      let userI = this.configList.columns
        .map(function(e) {
          return e.name;
        })
        .indexOf('user');
      if (userI != -1) this.configList.columns.splice(userI, 1);
    }
    await this.getStockHistories({ limit: this.limit });
  },
  methods: {
    RouterBack: function() {
      this.$router.back();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getStockHistories(filters) {
      filters.product = this.$route.params.id;
      filters.from  = this.filterOptions.dates[0]
      filters.to = this.filterOptions.dates[1]
      filters.orderRef = this.filterOptions.orderRef
      // filters.type="InStockTotal";
      const res = await this.$server.search('stockHistories', filters);
      
      /* if (res.content.results) {
               this.content = res.content.results;
               let stockHistories = this.content;
               for (let i in stockHistories) {
                 stockHistories[i].user = stockHistories[i].user.email;
                 stockHistories[i].date = stockHistories[i].date.split("T")[0];
                 stockHistories[i].product = stockHistories[i].product.name;
                 stockHistories[i].quantity = stockHistories[i].quantity;
                 stockHistories[i].reason = stockHistories[i].reason;
               }
       
               this.content = stockHistories;
               
             } else this.content = []*/
      if (res.content.results) {
        this.content = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
        for (let i in this.content) {
          this.content[i].country = this.content[i].warehouse.country;
          this.content[i].name_warehouse = this.content[i].warehouse.name;
        }
      } else this.content = [];
    },
    async refresh() {
      this.getStockHistories({ limit: this.limit });
    },
    async paginatation(direction) {
      var page = 0;
      if (direction == 'next') {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      const filters = {
        page: page,
        limit: this.limit,
      };
      this.getStockHistories(filters);
    },
  },
  watch:{
    filterOptions : {
      async handler(){
        await this.getStockHistories({ limit: this.limit });
      },
      deep:true,
    }
  },
  components: { StockInsights },
  computed: {
    userRole() {
      return this.$store.state.authenticatedUser.type.toUpperCase();
    },
    isUserCEO() {
      return this.userRole === 'ADMIN' || this.userRole === 'CEO';
    },
  },
};
</script>
